import { render, staticRenderFns } from "./CourseDetailsForm.vue?vue&type=template&id=6e7271ac&scoped=true&"
import script from "./CourseDetailsForm.vue?vue&type=script&lang=js&"
export * from "./CourseDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetailsForm.vue?vue&type=style&index=0&id=6e7271ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7271ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VContainer,VImg,VOverlay,VRow,VSelect,VTextField,VTextarea})
